import { Validator } from '@vista-digital/validator';
import { captchaConfigValidator } from '../../../../subcomponents/captcha/types/config';
export const defaultOccSecurityConfig = {
    captcha: undefined
};
export const occSecurityConfigValidator = Validator.object({
    captcha: Validator.optional(captchaConfigValidator)
});
//# sourceMappingURL=security.js.map